import React from "react";

export default ({ show }) => show
